import React from "react";
import {
  PHOTOGRAPHY_CONSENT_TEXT,
  PHOTOGRAPHY_CONSENT_TITLE,
} from "../shared/utils/photographyConsent";

/**
 * Per-child photography / media release with forced Yes / No segmented control.
 * @param {{ value: boolean | null | undefined, onChange: (next: boolean) => void, idPrefix?: string, disabled?: boolean, variant?: "warm" | "cool" }} props
 */
export default function PhotographyConsentBlock({
  value = null,
  onChange,
  idPrefix = "photo-consent",
  disabled = false,
  variant = "warm",
}) {
  const yesId = `${idPrefix}-yes`;
  const noId = `${idPrefix}-no`;
  const groupLabelId = `${idPrefix}-label`;

  return (
    <div
      className={`photography-consent photography-consent--${variant}`}
      role="group"
      aria-labelledby={groupLabelId}
    >
      <h4 className="photography-consent__title" id={groupLabelId}>
        {PHOTOGRAPHY_CONSENT_TITLE}
      </h4>
      <p className="photography-consent__text">{PHOTOGRAPHY_CONSENT_TEXT}</p>
      <div className="photography-consent-segmented">
        <button
          type="button"
          id={yesId}
          className={`photography-consent-segmented__btn photography-consent-segmented__btn--yes${
            value === true ? " is-selected" : ""
          }`}
          aria-checked={value === true}
          role="radio"
          disabled={disabled}
          onClick={() => onChange && onChange(true)}
        >
          <span className="photography-consent-segmented__icon" aria-hidden>
            ✓
          </span>
          Yes, I consent
        </button>
        <button
          type="button"
          id={noId}
          className={`photography-consent-segmented__btn photography-consent-segmented__btn--no${
            value === false ? " is-selected" : ""
          }`}
          aria-checked={value === false}
          role="radio"
          disabled={disabled}
          onClick={() => onChange && onChange(false)}
        >
          <span className="photography-consent-segmented__icon" aria-hidden>
            ✕
          </span>
          No, I do not consent
        </button>
      </div>
    </div>
  );
}
